import { t } from 'lib/i18n'

import { CataloguePage } from './CataloguePage'

export const EquipmentCataloguePage = () => (
  <CataloguePage
    kind="EQUIPMENT"
    title={t('المعدات', 'Equipment')}
    description={t('قائمة المعدات المرجعية التي تظهر كاقتراحات عند تعبئة قسم المعدات في التقرير.', 'Reference list of equipment suggested when filling in the equipment section of a report.')}
    icon="truck"
    itemLabel={t('معدة', 'equipment')}
  />
)
